module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_petiteHover-1f41e97150f8d24a4c663ffc794d60d5.jpg";